module.exports = __webpack_public_path__ + "static/media/bat3.97f96b26.png";